import React, { Component } from 'react';
import $ from 'jquery';
import { browserHistory, Link } from 'react-router';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';

export default class Web_Login extends Component{
  constructor(props,context){
    super(props);
    // this.router = context.router;
    this.state={
      error: false,
      err: false,
      err_pass: false,
      not_reg: '',
      invalid_pass: '',
      myNumber: '',
      mobile: localStorage.mobile_number,
    };
     this.handleSubmit = this.handleSubmit.bind(this);
     this.onMobileChange= this.onMobileChange.bind(this);
     this.passwordChange= this.passwordChange.bind(this);
  }

    componentDidMount()
    {
        if(localStorage.token && localStorage.user_id)
        {
          browserHistory.push('/web/home');
        }
       this.refs.pass.focus();
    }
    passwordChange()
    {
      this.setState({
        invalid_pass: '',
      })
    }
    verify_otp()
    {
          var baseUrl='https://aquadeals.in/admin/web3/user/';
          var data1 = {from: 'desktop_web',mobile: this.state.mobile,device_id: localStorage.getItem('push_device_id')}
          var data2=JSON.stringify(data1);
          $.ajax({
              method: 'POST',
              url: baseUrl+'forgotOtp',
              data: {req:data2},
              dataType: 'json',
              success: function(data)
              {
                  if(data.status==="success")
                  {
                    localStorage.setItem('mobile',data.mobile);
                    this.setState({
                      err: false,
                    })
                    browserHistory.push('/web/verify');
                    window.location.reload();
                  }
                  else if(data.status ==='fail')
                  {
                      this.setState({
                        err: true,
                        invalid_num: data.msg
                      })
                  }
                  else if(data.status === 'Mobile number is not registerd with us')
                  {
                      this.setState({
                        err: true,
                        invalid_num: data.status,
                      })
                  }
              }.bind(this),
              error: function(err)
              {
                // console.log("Forgot Password" + err);
              }
          });
    }
    handleSubmit(event)
    {
        event.preventDefault();
        var baseUrl='https://aquadeals.in/admin/web3/user/';
        var data1 = {from: 'desktop_web',mobile: this.refs.mobile.value,password: this.refs.pass.value,version:'',device_id: localStorage.getItem('push_device_id'),platform: ''}
        var data2 = JSON.stringify(data1);
        $.ajax({
          method: 'POST',
          url: baseUrl+'login',
          data: {req:data2},
          dataType:'json',
          success: function(data)
          {
            if(data.status ==="success")
            {
              localStorage.setItem('token',data.result[0].token);
              localStorage.setItem('user_id',data.result[0].id);
              localStorage.setItem('user_name',data.result[0].name);
              localStorage.setItem('user_mobile',data.result[0].mobile)
              localStorage.setItem('user_email',data.result[0].email);
            }
            else if(data.status ==="Invalid password")
            {
              this.setState({
                err_pass: 'true',
                invalid_pass: data.status,
                not_reg: '',
              });
            }
            else if(data.status==="Mobile number is not registerd with us")
            {
              this.setState({
                err: 'true',
                not_reg: data.status,
                invalid_pass: '',
              }).bind(this);
            }
            else if(data.status==="fail")
            {
              this.setState({
                  err: 'true',
                  invalid_pass: '',
                  not_reg: data.message,
              }).bind(this);        }
            else
            {
              this.setState({
                err: 'true',
                err_pass: 'true',
              });
            }
            if(localStorage.token && localStorage.w_r_s_dt)
            {
              browserHistory.push(localStorage.w_r_s_dt)
            }
            if(localStorage.token && localStorage.w_r_e_coupon_dt)
            {
              browserHistory.push(localStorage.w_r_e_coupon_dt)
            }
            if(localStorage.token && localStorage.w_r_e_s_dt)
            {
              browserHistory.push(localStorage.w_r_e_s_dt);
              // window.location.reload();
            }
            if(localStorage.token && localStorage.web_mycart)
            {
              browserHistory.push(localStorage.web_mycart);
              // window.location.reload();
            }
            if(localStorage.token && localStorage.w_r_enq_seller_page)
            {
              browserHistory.push(localStorage.w_r_enq_seller_page);
            }
            if(localStorage.token && localStorage.w_r_p_dt)
            {
              browserHistory.push(localStorage.w_r_p_dt)
              // window.location.reload();
            }
            if(localStorage.token && localStorage.w_r_e_p_dt)
            {
              browserHistory.push(localStorage.w_r_e_p_dt);
              // window.location.reload();
            }
            if(localStorage.token && localStorage.web_ofr_page)
            {
              browserHistory.push(localStorage.web_ofr_page);
            }
            if(localStorage.token && localStorage.profile)
            {
              browserHistory.push(localStorage.profile);
              // window.location.reload();
            }
            if(localStorage.token && localStorage.myaquacash)
            {
              browserHistory.push(localStorage.myaquacash);
              // window.location.reload();
            }
            if(localStorage.token && localStorage.web_share_earn)
            {
              browserHistory.push(localStorage.web_share_earn);
              // window.location.reload();
            }
            if(localStorage.token && localStorage.checkout)
            {
              browserHistory.push(localStorage.checkout);
              // window.location.reload();
            }
            if(localStorage.token && localStorage.order_details)
            {
              browserHistory.push(localStorage.order_details);
            }
            if(localStorage.token && localStorage.myorders)
            {
              browserHistory.push(localStorage.myorders);
            }
            if(localStorage.token && localStorage.w_r_p_deals)
            {
              browserHistory.push(localStorage.w_r_p_deals)
            }
            if(localStorage.token && localStorage.seed)
            {
              browserHistory.push(localStorage.seed);
            }
            if(localStorage.token && localStorage.nauplii)
            {
              browserHistory.push(localStorage.nauplii);
            }
            if(localStorage.token && localStorage.subdeals)
            {
              browserHistory.push(localStorage.subdeals);
            }
            if(localStorage.token && localStorage.offers)
            {
              browserHistory.push(localStorage.offers);
            }
            if(localStorage.token && localStorage.shipping)
            {
              browserHistory.push(localStorage.shipping);
            }
            if(localStorage.token && localStorage.notifications)
            {
              browserHistory.push(localStorage.notifications);
            }
            if(localStorage.token && localStorage.web_quickcart)
            {
              browserHistory.push(localStorage.web_quickcart);
            }
            if(localStorage.token && localStorage.view_rating)
            {
              browserHistory.push(localStorage.view_rating);
            }
            if(localStorage.token && localStorage.give_rating)
            {
              browserHistory.push(localStorage.give_rating);
            }
            if(localStorage.token && localStorage.w_modal_seed)
            {
              browserHistory.push(localStorage.w_modal_seed);
            }
            if(localStorage.token && localStorage.w_r_seed_deals)
            {
              browserHistory.push(localStorage.w_r_seed_deals)
            }
            if(localStorage.token && localStorage.w_r_e_p_dt)
            {
              browserHistory.push(localStorage.w_r_e_p_dt)
            }
            if(localStorage.token && localStorage.w_modal_details)
            {
              browserHistory.push(localStorage.w_modal_details);
            }
            if(localStorage.token && localStorage.web_pro_ofr_dtls)
            {
              browserHistory.push(localStorage.web_pro_ofr_dtls);
            }
            if(localStorage.token && localStorage.web_smartcart)
            {
              browserHistory.push(localStorage.web_smartcart);
            }
            if(localStorage.token && localStorage.web_wishlist)
            {
              browserHistory.push(localStorage.web_wishlist);
            }
            if(localStorage.token && localStorage.web_brand_details)
            {
              browserHistory.push(localStorage.web_brand_details);
            }
            else if(localStorage.token && data.status==="success" && !localStorage.w_r_s_dt && !localStorage.w_r_p_dt && !localStorage.w_r_e_s_dt && !localStorage.w_r_e_p_dt && !localStorage.w_r_seed_deals && !localStorage.w_r_p_deals && !localStorage.w_r_e_coupon_dt && !localStorage.w_modal_details && !localStorage.w_r_enq_seller_page && !localStorage.web_mycart && !localStorage.shipping && !localStorage.order_details && !localStorage.view_rating && !localStorage.give_rating && !localStorage.myorders && !localStorage.web_quickcart && !localStorage.checkout && !localStorage.profile && !localStorage.web_share_earn && !localStorage.myaquacash && !localStorage.notifications && !localStorage.web_ofr_page && !localStorage.seed && !localStorage.nauplii && !localStorage.subdeals && !localStorage.offers && !localStorage.web_pro_ofr_dtls && !localStorage.web_smartcart && !localStorage.web_wishlist && !localStorage.web_brand_details)
            {
              browserHistory.push('/web/home');
            }
            if(localStorage.token && localStorage.getItem('redirect_url'))
            {
              browserHistory.push(localStorage.getItem('redirect_url'));
            }
          }.bind(this),
          error: function(err)
          {
            // console.log("Login error" + err);
          }
        })
    }
    onMobileChange(event)
    {
      var invalidChars = /[^0-9]/gi;
      if(invalidChars.test(event.target.value)) 
      {
          event.target.value = event.target.value.replace(invalidChars,"");
      }
      else
      {
        this.setState({
          err: true,
        })
      }
    }
  render(){
    $(window).scrollTop(0);
    localStorage.removeItem('h_type');
    return (
            <div className="lgt_gry web_deals web_login_page">
                <WebHeaderInner />
                // <div className="clr">&nbsp;</div>
                // <div className="clr">&nbsp;</div>
                <section className="container dels_cntnt log_web_blk">
                    <div className="row">
                      <div className="col-md-12 del_rgt">
                        <div className="del_rgt_blk">
                          <div className="del_dtl">
                          <div className="">
                        <div className="col-md-6 col-md-offset-3">
                          <div className="thumbnail">
                        <div>
                          <div className="newlogin_logo"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png'} alt=" "/></div>
                          <form className="mtrl_elmnts" onSubmit={this.handleSubmit}>
                            <div className="col-md-12">
                                <div className="group">  
                                  <img src={'https://aquadeals.in/admin/assets/icons/web_icons/cell_dl.png'} alt="" style={{position:'absolute',top:'9px',left:'0px'}} />
                                  <input type="text" value={this.state.mobile} placeholder="Mobile Number" ref="mobile" maxLength={10} onChange={this.onMobileChange} required />
                                  <span className="highlight"></span>
                                  <span className="bar"></span>
                                  <span style={{color:'red'}}>{this.state.err ? this.state.not_reg : '' }</span>
                                </div>
                                <div className="group">      
                                  <img src={'https://aquadeals.in/admin/assets/icons/web_icons/lock.png'} alt="" style={{position:'absolute',top:'11px',left:'0px'}} />
                                  <input type="password" placeholder="Password" ref="pass" required onChange={this.passwordChange} />
                                  <span className="highlight"></span>
                                  <span className="bar"></span>
                                  <span style={{color:'red'}}>{this.state.err_pass ? this.state.invalid_pass : ''}</span>
                                </div>
                                <div><button onSubmit={this.handleSubmit.bind(this)} action="submit" className="btn web_lgn_btn">Enter <i className="glyphicon glyphicon-menu-right"></i></button></div>
                                <div className="clr">&nbsp;</div>
                                <div className="forgot_pasword">
                                  <h5>Forgot your password?</h5>
                                  <div className="tap"><Link onClick={this.verify_otp.bind(this)} style={{cursor:'pointer'}}>Tap here to reset password</Link></div> 
                                  {/* <div className="tap"><Link to={"/reset"} style={{cursor:'pointer'}}>Tap here to reset password</Link></div> */}
                                </div>  
                            </div>
                          </form>
                        </div>
                        <div className="clr">&nbsp;</div>
                        </div>
                        </div>
                        </div>
                      
                      <div className="clr">&nbsp;</div>
                      <div className="clr">&nbsp;</div>
                      </div>
                          </div>
                        </div>
                      </div>
                    <div className="clr">&nbsp;</div> 
                    <div className="clr">&nbsp;</div>
                    </section>
                    <WebFooter />
                    </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Auth/Web_login.js
 **/